import useSWR from "swr"
import {API_ECP_PROJECTS} from "../constants/apiUrls"

export default function useEcpKeypoints(projectId) {
    const {data, mutate, error} = useSWR(`${API_ECP_PROJECTS}/${projectId}/keypoints`, {revalidateOnFocus: false})
    return {
        ecpKeypoints: data,
        mutateEcpKeypoints: mutate,
        isLoadingEcpKeypoints: !error && !data,
        isErrorEcpKeypoints: error
    }
}